import { ReactNode, createContext, useState } from 'react';
import { FormDataType } from 'types';

export interface FormContextProps {
    formData: FormDataType;
    updateFormData: (newData: Partial<FormDataType>) => void;
    resetForm: () => void;
}

export const FormContext = createContext<FormContextProps | undefined>(undefined);

export const FormProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [formData, setFormData] = useState<FormDataType>({});

    const updateFormData = (newData: Partial<FormDataType>) => {
        setFormData(prev => ({ ...prev, ...newData }));
    };

    const resetForm = () => setFormData({});

    return <FormContext.Provider value={{ formData, updateFormData, resetForm }}>{children}</FormContext.Provider>;
};
